import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { motion } from 'framer-motion';

import { setContactDetailsModalClosed, fetchSupporter, setModalContactDetails } from '../../actions/supporters';

import Loading from '../Loading';
import Modal from '../Modals/Modal';
import SupporterDetailsForm from './SupporterDetailsForm';
import SupporterDetails from './SupporterDetails';
import fadeInUp from '../../helpers/Animations';
import '../../styles/components/modals/_contact-details.scss';

const ContactDetailsModal = ({ contactID, setContactDetails, isOpen, onClose, contacts, loading, error, fetchSupporterDetails, canEdit }) => {
  const [view, setView] = useState('show');

  const handleModalClose = () => {
    setTimeout(() => {
      onClose();
      setView('show');
    }, 300);
  };

  useEffect(() => {
    const storedContact = contacts.find((contact) => contact.contact_id === contactID);
    if (storedContact !== undefined) {
      setContactDetails(storedContact);
    } else if (contactID) {
      fetchSupporterDetails(contactID);
    }
  }, [contactID]);

  const handleEditClick = () => setView('edit');

  if (error) {
    return (
      <Modal isOpen={isOpen} onClose={onClose} modalName="contact-details-modal">
        <motion.div animate={fadeInUp.animate} transition={fadeInUp.transition} className="contact-details-modal__wrapper">
          Something went wrong. Please try again.
        </motion.div>
      </Modal>
    );
  }

  return (
    <Modal isOpen={isOpen} onClose={handleModalClose} modalName="contact-details-modal" hasCloseButton={!loading}>
      {loading || !contactID ? (
        <Loading />
      ) : (
        <motion.div animate={fadeInUp.animate} transition={fadeInUp.transition} className="contact-details-modal__wrapper">
          {view === 'edit' && canEdit ? (
            <SupporterDetailsForm onClose={handleModalClose} />
          ) : (
            <SupporterDetails handleEditClick={canEdit ? handleEditClick : null} onClose={handleModalClose} />
          )}
        </motion.div>
      )}
    </Modal>
  );
};

ContactDetailsModal.defaultProps = {
  contacts: [],
  isOpen: false,
  contactID: null,
  canEdit: false,
};

ContactDetailsModal.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  contacts: PropTypes.array,
  contactID: PropTypes.number,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  error: PropTypes.bool.isRequired,
  canEdit: PropTypes.bool,
  setContactDetails: PropTypes.func.isRequired,
  fetchSupporterDetails: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
  fetchSupporterDetails: (contactID) => dispatch(fetchSupporter(contactID)),
  setContactDetails: (contactDetails) => dispatch(setModalContactDetails(contactDetails)),
  onClose: () => dispatch(setContactDetailsModalClosed()),
});

const mapStateToProps = (state) => ({
  contacts: state.supporters.contacts,
  contactID: state.supporters.contactModal.contactID,
  loading: state.supporters.contactModal.loading,
  error: state.supporters.contactModal.error,
  isOpen: state.supporters.contactModal.isOpen,
  canEdit: state.supporters.contactModal.canEdit,
});

export default connect(mapStateToProps, mapDispatchToProps)(ContactDetailsModal);
